// calculateSubtotal — faithful port of OrderCreateViewModel.kt:4430-4505 (calculateSubTotal).
// The AUTHORITATIVE subtotal that sets mSubTotal for all money math.
//
// Parity quirks preserved (see spec 2026-07-02-web-register-design.md §8):
//  - unitPrice = orderUnitNewPrice>0 ? orderUnitNewPrice : orderUnitPrice
//  - $ item discount is multiplied by orderCount; % item discount is PER-UNIT (NOT ×count)
//  - % item discount uses truncate2 (truncation)
//  - lottery/scratcher payout lines are bucketed separately, not added to subtotal
//  - split/discount/refund synthetic lines are excluded

import { toNum, truncate2 } from "./money";

export function calculateSubtotal(cart) {
  let subtotal = 0;
  let lotteryBuyAmount = 0;
  let lotteryPayoutAmount = 0;
  let scratcherPayoutAmount = 0;

  for (const m of cart) {
    if (m.isSplitPaymentDiscount || m.isSplitPayment || m.isSplitRefund) continue;

    const unitPrice =
      toNum(m.orderUnitNewPrice) > 0 ? toNum(m.orderUnitNewPrice) : toNum(m.orderUnitPrice);
    const count = toNum(m.orderCount);

    let discountPrice = 0;
    if (toNum(m.orderDiscount) > 0) {
      discountPrice = toNum(m.orderDiscount) * count;
    } else if (toNum(m.orderDiscountPercent) > 0) {
      discountPrice = truncate2((unitPrice * toNum(m.orderDiscountPercent)) / 100); // per-unit
    }

    if (m.isLotteryPayout) {
      lotteryPayoutAmount += unitPrice * count;
    } else if (m.isScratcherPayout) {
      scratcherPayoutAmount += unitPrice * count;
    } else {
      subtotal += unitPrice * count - discountPrice;
      if (m.isLotteryTicket === "1") lotteryBuyAmount += unitPrice * count;
    }
  }

  return { subtotal, lotteryBuyAmount, lotteryPayoutAmount, scratcherPayoutAmount };
}
